export default "__VITE_ASSET__CJTks_zl__"